import getSelected from './getSelected';

// ----------------------------------------------------------------------------

function getValue(element: HTMLElement): string | undefined {
    return getSelected(element);
}

// ----------------------------------------------------------------------------

export default getValue;
